// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iUD51OVO3qMyTmyTEgYG{width:105px;height:32px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/savedReplies/ui/SavedRepliesAction/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,WAAA","sourcesContent":[".createButton {\n  width: 105px;\n  height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createButton": `iUD51OVO3qMyTmyTEgYG`
};
export default ___CSS_LOADER_EXPORT___;
